// js
import React from 'react';
import PropTypes from 'prop-types';
// css
import '../../styles/components/sources/TemplateDownloaderCheckbox.scss';


const TemplateDownloaderCheckbox = ({ title, description, name, checked, onClick, disabled }) => (

  <label className='template-downloader-checkbox'>
    <div className='template-downloader-checkbox__input'>
      <input
        type='checkbox'
        onClick={event => onClick && onClick(name, event.target.checked)}
        checked={checked}
        disabled={disabled}
      />
    </div>
    <div className='template-downloader-checkbox__meta'>
      <div className='template-downloader-checkbox__title'>
        {title}
      </div>
      <div className='template-downloader-checkbox__description'>
        {description}
      </div>
    </div>
  </label>
);

TemplateDownloaderCheckbox.defaultProps = {
  disabled: false
};

TemplateDownloaderCheckbox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default TemplateDownloaderCheckbox;



// WEBPACK FOOTER //
// ./src/components/sources/TemplateDownloaderCheckbox.js